export const PerformanceInsightsLocale = {
  en: {
    campaign_performance: "Campaign Performance",
    property_name: "Property Name",
    campaign_name: "Campaign Name",
    platform: "Platform",
    campaign_status: "Campaign Status",
    campaign_id: "Campaign ID",
    leads: "Leads",
    ActiveLeads: "Active Leads",
    lead_view: "Leads",
    qualified: "Qualified",
    media_details: "Media Details",
    unqualified: "Unqualified",
    totals:
      "{{propertyName}} | Total Leads {{totalLeads}} | Qualified Leads {{qualified}} | Unqualified Leads {{unqualified}}",
    grand_total: "Grand Total",
    exporting: "Exporting...",
    export_excel: "Export Excel",
    export_campaign_performance_error: "Failed to export. Please try again.",
    agent: "Agent",
    "branch/team": "Branch / Team",
    performance: "Performance",
    total_assigned: "Total Assigned",
    currently_assigned: "Currently Assigned",
    qualified: "Qualified",
    unqualified: "Unqualified",
    updated: "Updated",
    not_updated: "Not Updated",
    lost: "Lost",
    closed: "Closed",
    transacted: "Transacted",
    agent_name: "Agent Name",
    branch_name: "Branch Name",
    performance_tag: "Performance Tag",
    team_name: "Team Name",
    agent_performance: "Agent Performance",
    "clear-filters": "Clear Filters",
  },
  ar: {
    campaign_performance: "أداء الحملة",
    property_name: "اسم العقار",
    campaign_name: "اسم الحملة",
    platform: "المنصة",
    campaign_status: "حالة الحملة",
    media_details: "تفاصيل الوسائط",
    campaign_id: "معرّف الحملة",
    ActiveLeads: "العملاء المحتملون النشطون",
    leads: "العملاء المحتملون",
    qualified: "مؤهل",
    unqualified: "غير مؤهل",
    totals:
      "{{propertyName}} | إجمالي العملاء المحتملين {{totalLeads}} | المؤهلون {{qualified}} | غير المؤهلين {{unqualified}}",
    grand_total: "الإجمالي الكلي",
    exporting: "جارٍ التصدير",
    export_excel: "تصدير إلى Excel",
    export_campaign_performance_error:
      "فشل في تصدير أداء الحملة. يرجى المحاولة مرة أخرى.",
    agent: "الوكيل",
    "branch/team": "الفرع / الفريق",
    performance: "الأداء",
    total_assigned: "إجمالي المعين",
    currently_assigned: "المعين حاليًا",
    qualified: "مؤهل",
    unqualified: "غير مؤهل",
    updated: "تم التحديث",
    not_updated: "لم يتم التحديث",
    lost: "مفقود",
    closed: "مغلق",
    transacted: "تمت المعاملة",
    agent_name: "اسم الوكيل",
    branch_name: "اسم الفرع",
    performance_tag: "علامة الأداء",
    lead_view: "العملاء المحتملون",
    team_name: "اسم الفريق",
    agent_performance: "أداء الوكيل",
    "clear-filters": "مسح الفلاتر",
  },
  ru: {
    campaign_performance: "Эффективность кампании",
    property_name: "Название объекта",
    campaign_name: "Название кампании",
    platform: "Платформа",
    campaign_status: "Статус кампании",
    media_details: " Детали медиа",
    campaign_id: "ID кампании",
    leads: "Лиды",
    qualified: "Квалифицированные",
    unqualified: "Неквалифицированные",
    totals:
      "{{propertyName}} | Всего лидов {{totalLeads}} | Квалифицированные {{qualified}} | Неквалифицированные {{unqualified}}",
    grand_total: "Общий итог",
    exporting: "Экспорт",
    export_excel: "Экспорт в Excel",
    export_campaign_performance_error:
      "Не удалось экспортировать эффективность кампании. Пожалуйста, попробуйте снова.",
    agent: "Агент",
    "branch/team": "Филиал / Команда",
    performance: "Производительность",
    total_assigned: "Всего назначено",
    currently_assigned: "Назначено сейчас",
    qualified: "Квалифицирован",
    ActiveLeads: "Квалифи ирован ",
    unqualified: "Неквалифицирован",
    updated: "Обновлено",
    not_updated: "Не обновлено",
    lost: "Потерян",
    closed: "Закрыт",
    transacted: "Совершено",
    agent_name: "Имя агента",
    lead_view: "Тег аге нта",
    branch_name: "Название филиала",
    performance_tag: "Тег производительности",
    team_name: "Название команды",
    agent_performance: "Эффективность агента",
    "clear-filters": "Очистить фильтры",
  },
  cn: {
    campaign_performance: "广告活动绩效",
    property_name: "物业名称",
    campaign_name: "广告活动名称",
    platform: "平台",
    campaign_status: "广告活动状态",
    ActiveLeads: "广告 活动状 态  ",
    campaign_id: "广告活动编号",
    media_details: "媒体详情",
    leads: "潜在客户",
    qualified: "合格",
    lead_view: "总潜 在客户",
    unqualified: "不合格",
    totals:
      "{{propertyName}} | 总潜在客户 {{totalLeads}} | 合格 {{qualified}} | 不合格 {{unqualified}}",
    grand_total: "总计",
    exporting: "正在导出",
    export_excel: "导出为 Excel",
    export_campaign_performance_error: "导出广告活动绩效失败，请重试。",
    agent: "代理",
    "branch/team": "分支 / 团队",
    performance: "绩效",
    total_assigned: "总分配",
    currently_assigned: "当前分配",
    qualified: "合格",
    unqualified: "不合格",
    updated: "已更新",
    not_updated: "未更新",
    lost: "丢失",
    closed: "已关闭",
    transacted: "已成交",
    agent_name: "代理名称",
    branch_name: "分支名称",
    performance_tag: "绩效标签",
    team_name: "团队名称",
    agent_performance: "代理绩效",
    "clear-filters": "清除筛选",
  },
};

export const PerformanceInsightsTranslationPath = "PerformanceInsights";
